<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
           <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1 class="display-3  text-white">Mobile Apps
                                </h1>
                                <p class="lead  text-white">
                                    In the stage where intelligence leads the development, artificial intelligence technology is becoming more and more widely used in mobile Internet Apps, and more and more artificial intelligence technologies are participating more in the development of mobile Internet. Due to its unique universality, autonomy, and iterative optimization characteristics, artificial intelligence technology can deal with more complex data structures and data environments in the data processing link, and obtain more rigorous and stable models and deduction results. Artificial intelligence technology is constantly promoting the completion of new changes in the form of mobile Internet, completing more autonomous information capture, smarter analysis and judgment, more autonomous service provision, and smarter cloud-to-end integration.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="/img/image_process.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Image process</h3>
                            <p class="text-white">The use of artificial intelligence for image processing in mobile apps includes recognizing the current scene and adjusting parameters by itself, avoiding exposure and color cast, and adjusting the background blur according to user needs. Carrying out race, gender, age, skin color, and skin quality on portraits provides users with personalized beauty and filters. Post-optimize pictures and videos.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img src="/img/audio_assistant.jpg" class="img-fluid">
    
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3 class="text-white">Voice assitant</h3>
                            <p class="text-white">The voice assistant has functions such as system settings, smart reminders, calling third-party applications, controlling other smart devices around, turning off the screen, and voice search. Smart translation can perform voice conversion by selecting language conversion. Voice search first converts speech into text, and then performs text matching and search.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="/img/performance_analysis.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Performance analysis</h3>
                            <p class="text-white">Mobile application performance analysis mainly focuses on mobile application end-to-end QoE analysis, user stickiness analysis, and business collaboration friendliness analysis. Distinguish social applications, instant messaging applications, audio and video applications, cloud applications, browser applications and game applications according to different application types, and analyze the demand for energy consumption, delay, traffic, speed and other indicators of applications in different fields.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img src="/img/authentication.jpg" class="img-fluid">
    
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3 class="text-white">Authentication</h3>
                            <p class="text-white">Use big data graph analysis for authentication analysis to enhance the security of the original password login method. User big data atlas is to record data through various behavior patterns of users on the Internet, perform analysis based on machine learning algorithms, combined with biometric identification and authentication, and finally output the analysis and recognition results.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "autonomous-driving",
  components: {
      
  }
};
</script>